export default __webpack_public_path__ + "static/media/affiche2008.15ebe2e9.png";